import React from 'react';
import { Button, IconButton, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getIsPageBarOpen } from 'redux/DashboardSliceV2';
import FigmaFileDownloadIcon from 'components/Icons/FigmaFileDownloadIcon';
import {
  accent,
  controlHeight,
  font,
  fontSize,
  neutral,
  radius,
  text as textToken,
} from 'styles/revampTokens';

import PreviewModal from './PreviewModal';

const ExportButtonNew = () => {
  const isPageBarOpen = useSelector(getIsPageBarOpen);
  const [smallDevice] = useMediaQuery('(max-width: 1100px)');
  const isSmallDevice = (smallDevice && isPageBarOpen) || smallDevice;
  const { isOpen: isPreviewOpen, onOpen: onPreviewOpen, onClose: onPreviewClose } = useDisclosure();

  return (
    <>
      {/* Same radius.control corner and controlHeight as the Create button
          right next to it — this was still on the pre-token 9px/#D9D9D9 pair,
          which is why the two didn't line up. Icon stays accent purple (asked
          for explicitly), everything else on the token/neutral system. */}
      {isSmallDevice ? (
        <IconButton
          aria-label='Export'
          icon={<FigmaFileDownloadIcon width={14} height={14} color={accent.solid} />}
          backgroundColor={neutral.surface}
          border={`1px solid ${neutral.border}`}
          borderRadius={radius.control}
          height={controlHeight}
          fontSize={fontSize.body}
          fontWeight='500'
          fontFamily={font.body}
          width='fit-content'
          title='Export'
          padding='0 14px'
          color={textToken.primary}
          _hover={{ backgroundColor: neutral.surfaceHover }}
          onClick={onPreviewOpen}
        />
      ) : (
        <Button
          backgroundColor={neutral.surface}
          border={`1px solid ${neutral.border}`}
          borderRadius={radius.control}
          height={controlHeight}
          leftIcon={<FigmaFileDownloadIcon width={14} height={14} color={accent.solid} />}
          fontSize={fontSize.body}
          fontWeight='500'
          fontFamily={font.body}
          width='fit-content'
          title='Export'
          padding='0 14px'
          color={textToken.primary}
          _hover={{ backgroundColor: neutral.surfaceHover }}
          onClick={onPreviewOpen}
        >
          Export
        </Button>
      )}

      <PreviewModal isOpen={isPreviewOpen} onClose={onPreviewClose} selectedPages={[]} />
    </>
  );
};

export default ExportButtonNew;
